<template>
  <div>
    <div v-if="menuOpen" class="overlay" @click="closeMenu"></div>

    <aside class="sidebar" :class="{ 'is-open': menuOpen }" @click.stop>
      <div class="side-head">
        <router-link to="/dashboard" class="side-brand" @click="closeMenu">
          <span class="brand-mark">J</span>
          <span><b>JuLiam</b><strong>ARCADE</strong></span>
        </router-link>
        <button class="icon-btn" type="button" @click="closeMenu" aria-label="Cerrar">×</button>
      </div>

      <nav class="menu-links">
        <router-link to="/dashboard" class="nav-link" @click="closeMenu">Inicio</router-link>
        <router-link to="/wallet" class="nav-link" @click="closeMenu">Mi wallet</router-link>
        <router-link to="/menu" class="nav-link" @click="closeMenu">Menú digital</router-link>
        <router-link v-if="isAdmin" to="/recetas" class="nav-link" @click="closeMenu">Recetario</router-link>
        <router-link v-if="isAdmin" to="/catalogo" class="nav-link" @click="closeMenu">Catálogo</router-link>
        <router-link v-if="isAdmin" to="/configuracion/lealtad" class="nav-link" @click="closeMenu">Lealtad GT</router-link>
        <router-link v-if="isAdmin" to="/usuarios" class="nav-link" @click="closeMenu">Usuarios</router-link>
        <router-link :to="'/dashboard/user/edit/' + $store.state.user.token" class="nav-link" @click="closeMenu">Mi perfil</router-link>
        <button class="nav-link danger" type="button" @click="logoutAndClose">Cerrar sesión</button>
      </nav>
    </aside>

    <nav class="topbar">
      <div class="topbar-inner">
        <button class="hamb" type="button" @click="toggleMenu" aria-label="Abrir menu"><span></span><span></span><span></span></button>
        <router-link to="/dashboard" class="top-brand">
          <span class="brand-mark compact">J</span>
          <span><b>JuLiam</b><strong>ARCADE</strong></span>
        </router-link>
        <div v-if="showPoints" class="points-chip">{{ formattedPoints }} pts</div>
        <router-link v-else class="preview-link" to="/wallet">Mi wallet</router-link>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import axios from 'axios'

export default {
  name: 'NavBar',
  data() { return { menuOpen: false, walletPoints: null } },
  computed: {
    isAdmin() {
      return ['administrador', 'superadministrador'].includes(this.$store.state.role)
    },
    showPoints() {
      return this.$route.path === '/wallet' && this.walletPoints !== null
    },
    formattedPoints() {
      const n = Number(this.walletPoints || 0)
      return Number.isInteger(n) ? String(n) : n.toFixed(2).replace(/0+$/, '').replace(/\.$/, '')
    }
  },
  watch: {
    '$route.path': { immediate: true, handler(path) { if (path === '/wallet') this.loadPoints() } },
    '$store.state.user.token'() { if (this.$route.path === '/wallet') this.loadPoints() }
  },
  methods: {
    ...mapActions(['logout']),
    toggleMenu() { this.menuOpen = !this.menuOpen },
    closeMenu() { this.menuOpen = false },
    async loadPoints() {
      const token = this.$store.state.user && this.$store.state.user.token
      if (!token) return
      try {
        const { data } = await axios.get('/api/loyalty/wallet', { headers: { Authorization: `Bearer ${token}` } })
        this.walletPoints = data?.account?.points_balance ?? 0
      } catch (_error) {
        this.walletPoints = null
      }
    },
    logoutAndClose() {
      this.logout()
      this.closeMenu()
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.overlay { position: fixed; inset: 0; background: rgba(1, 3, 10, .7); backdrop-filter: blur(8px); z-index: 40; }
.topbar { position: fixed; top: 0; left: 0; right: 0; height: 64px; z-index: 30; background: rgba(5, 8, 19, .9); border-bottom: 1px solid rgba(76, 245, 255, .18); backdrop-filter: blur(16px); box-shadow: 0 8px 28px rgba(0, 0, 0, .24); }
.topbar-inner { height: 64px; max-width: 1360px; margin: 0 auto; display: grid; grid-template-columns: 54px 1fr 120px; align-items: center; gap: 10px; padding: 0 16px; }
.hamb { width: 44px; height: 44px; border-radius: 10px; border: 1px solid rgba(76, 245, 255, .35); background: rgba(76, 245, 255, .055); color: #4cf5ff; cursor: pointer; display: grid; place-items: center; gap: 0; padding: 10px; }
.hamb span { display: block; width: 18px; height: 2px; border-radius: 99px; background: #4cf5ff; box-shadow: 0 0 8px rgba(76, 245, 255, .7); }
.top-brand, .side-brand { display: flex; align-items: center; gap: 10px; color: #f5f7ff; text-decoration: none; }
.top-brand { justify-self: center; }
.top-brand > span:last-child, .side-brand > span:last-child { display: grid; line-height: .82; text-align: left; }
.top-brand b, .side-brand b { font-size: 15px; letter-spacing: -.03em; }
.top-brand strong, .side-brand strong { color: #4cf5ff; font: 900 17px/1 ui-monospace, SFMono-Regular, Menlo, monospace; letter-spacing: .08em; }
.brand-mark { width: 42px; height: 42px; display: grid; place-items: center; border: 2px solid #4cf5ff; color: #ff3fd8; font: 900 23px/1 ui-monospace, SFMono-Regular, Menlo, monospace; clip-path: polygon(10% 0, 100% 0, 100% 78%, 77% 100%, 0 100%, 0 12%); box-shadow: 0 0 14px rgba(76, 245, 255, .3); }
.brand-mark.compact { width: 36px; height: 36px; font-size: 19px; }
.preview-link { justify-self: end; color: #4cf5ff; text-decoration: none; font: 900 11px/1 ui-monospace, SFMono-Regular, Menlo, monospace; text-transform: uppercase; letter-spacing: .08em; }
.points-chip { justify-self: end; border: 1px solid rgba(167, 255, 79, .45); background: rgba(167, 255, 79, .09); color: #a7ff4f; border-radius: 9px; padding: 8px 12px; font: 900 12px/1 ui-monospace, SFMono-Regular, Menlo, monospace; white-space: nowrap; box-shadow: 0 0 16px rgba(167, 255, 79, .08); }
.sidebar { position: fixed; top: 0; bottom: 0; left: 0; width: min(340px, 92vw); background: linear-gradient(180deg, rgba(11, 16, 32, .99), rgba(5, 8, 19, .99)); z-index: 50; transform: translateX(-105%); transition: transform .22s ease; box-shadow: 24px 0 60px rgba(0,0,0,.52); padding: 18px; overflow-y: auto; border-right: 1px solid rgba(255, 63, 216, .25); }
.sidebar.is-open { transform: translateX(0); }
.side-head { display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid rgba(255,255,255,.1); padding-bottom: 16px; margin-bottom: 18px; }
.icon-btn { border: 1px solid rgba(255,255,255,.2); background: rgba(255,255,255,.04); color: #949db8; width: 36px; height: 36px; border-radius: 9px; cursor: pointer; font-weight: 900; }
.menu-links { display: grid; gap: 10px; }
.nav-link { border: 1px solid rgba(255,255,255,.1); background: rgba(255,255,255,.025); color: #c3c9da; border-radius: 10px; padding: 14px; text-decoration: none; font: 800 11px/1 ui-monospace, SFMono-Regular, Menlo, monospace; letter-spacing: .07em; text-transform: uppercase; text-align: left; cursor: pointer; }
.nav-link.router-link-active, .nav-link:hover { border-color: rgba(76, 245, 255, .5); background: rgba(76, 245, 255, .08); color: #4cf5ff; }
.nav-link.danger { color: #ff3fd8; width: 100%; border-color: rgba(255, 63, 216, .2); }
@media (max-width: 620px) { .preview-link { display: none; } .top-brand > span:last-child { display: none; } .topbar-inner { grid-template-columns: 54px 1fr 100px; } }
</style>
